import { useEffect } from "react";
import { useForm } from "react-hook-form";

import {
  InputDateControllerVertical,
  SelectControllerVertical,
} from "@components";

import { useLanguage } from "@hooks/useLanguage";

import { getConvertedUnitData } from "@helpers/baseDataConvert";
import { getEmployeeServiceDataConvert } from "@helpers/employeeServiceDataConvert";
import { ticketDropdownDataConverter } from "@helpers/tickets/ticketDropdownDataConverter";

import { FORM_FIELDS } from "@constants/form";
// import { statusENUM } from "@containers/Tickets/statusData";

const {
  TYPE,
  ASSIGNED_TO,
  CATEGORY,
  PRIORITY,
  // STATUS,
  UNIT,
  FROM_DATE,
  TO_DATE,
} = FORM_FIELDS.E_TICKET.TICKET_DETAILS;

export const AllTicketsFilter = ({
  wings,
  commonInfo,
  handleQuery,
  ticketDropdown: { ticketTypes, categories, priorities },
  handleEmployeeQuery,
}: any) => {
  const { language } = useLanguage();
  const { register, control, setValue, watch } = useForm();

  const fromDate = watch(FROM_DATE);
  const toDate = watch(TO_DATE);

  const units = watch(UNIT);

  useEffect(() => {
    handleQuery(FROM_DATE, fromDate === "" ? null : fromDate);
    handleQuery(TO_DATE, toDate === "" ? null : toDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate]);

  useEffect(() => {
    if (units) {
      handleEmployeeQuery("unitId", units);
    } else {
      setValue(ASSIGNED_TO, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [units]);

  return (
    <div className="bg-light rounded p-10 mb-10">
      <div className="row pb-0 mb-0">
        <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.TYPE"
          name={TYPE}
          register={{ ...register(TYPE) }}
          options={ticketDropdownDataConverter(ticketTypes)}
          setValue={setValue}
          isSearchable
          selectAction={(e) => handleQuery(TYPE, e)}
          control={control}
          cols={3}
        />
        <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.CATEGORY"
          name={CATEGORY}
          register={{ ...register(CATEGORY) }}
          options={ticketDropdownDataConverter(categories)}
          setValue={setValue}
          isSearchable
          selectAction={(e) => handleQuery(CATEGORY, e)}
          control={control}
          cols={3}
        />

        <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.PRIORITY"
          name={PRIORITY}
          register={{ ...register(PRIORITY) }}
          options={ticketDropdownDataConverter(priorities)}
          setValue={setValue}
          isSearchable
          selectAction={(e) => handleQuery(PRIORITY, e)}
          control={control}
          cols={3}
        />
        {/* <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.STATUS"
          name={STATUS}
          register={{ ...register(STATUS) }}
          options={statusENUM}
          setValue={setValue}
          selectAction={(e) => handleQuery(STATUS, e)}
          control={control}
          cols={3}
        /> */}

        <InputDateControllerVertical
          control={control}
          label="TICKETS.TICKET_LIST.FORM.SELECT.FROM_DATE"
          name={FROM_DATE}
          register={{
            ...register(FROM_DATE),
          }}
          cols={3}
        />
        <InputDateControllerVertical
          control={control}
          label="TICKETS.TICKET_LIST.FORM.SELECT.TO_DATE"
          name={TO_DATE}
          register={{
            ...register(TO_DATE),
          }}
          cols={3}
        />
        <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.UNIT"
          name={UNIT}
          register={{ ...register(UNIT) }}
          options={getConvertedUnitData(wings, language)}
          setValue={setValue}
          isSearchable
          selectAction={(e) => handleQuery(UNIT, e)}
          control={control}
          cols={3}
        />
        <SelectControllerVertical
          label="TICKETS.TICKET_LIST.FORM.SELECT.ASSIGN_TO"
          name={ASSIGNED_TO}
          register={{ ...register(ASSIGNED_TO) }}
          options={getEmployeeServiceDataConvert(commonInfo, language)}
          setValue={setValue}
          isSearchable
          selectAction={(e) => handleQuery(ASSIGNED_TO, e)}
          control={control}
          cols={3}
          disabled={!units}
        />
      </div>
    </div>
  );
};
